import script from "./electricity.vue?vue&type=script&setup=true&lang=js"
export * from "./electricity.vue?vue&type=script&setup=true&lang=js"

import "./electricity.vue?vue&type=style&index=0&id=acce61bc&lang=css"

const __exports__ = script;

export default __exports__